import { Body, Container, Head, Html, Preview, Section, Text } from '@react-email/components';
import { BaseEmailTemplateProps } from './type';


type ClubMembershipDeactivatedEmailProps = BaseEmailTemplateProps<any, any>;

export function ClubMembershipDeactivatedEmail({
  emailMessages,
  userVariables,
  contextVariables,
}: ClubMembershipDeactivatedEmailProps & { emailMessages: any; locale: string }) {
  const { store } = contextVariables;
  const { subject, body } = userVariables;

  return (
    <Html>
      <Head />
      <Preview>{subject}</Preview>

      <Body style={main}>
        <Container style={container}>
          <Section style={header}>
            <Text style={storeName}>{store?.name}</Text>
          </Section>

          <Section style={messageSection}>
            <div dangerouslySetInnerHTML={{ __html: body }} style={messageText} />
          </Section>

          <Text style={footerText}>{emailMessages.footer_text}</Text>
        </Container>
      </Body>
    </Html>
  );
}

const main = {
  fontFamily:
    '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif',
  backgroundColor: '#ffffff',
};

const container = {
  margin: '0 auto',
  padding: '40px 20px',
  width: '600px',
  maxWidth: '100%',
};

const header = {
  marginBottom: '32px',
};

const storeName = {
  fontSize: '24px',
  lineHeight: '1.3',
  fontWeight: '700',
  color: '#111827',
  margin: '0',
  textAlign: 'center' as const,
};

const messageSection = {
  marginBottom: '32px',
};

const messageText = {
  fontSize: '16px',
  lineHeight: '1.5',
  color: '#374151',
  margin: '0',
  textAlign: 'left' as const,
};

const footerText = {
  fontSize: '14px',
  color: '#6b7280',
  textAlign: 'center' as const,
  margin: '0',
};
